
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cRIcG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f3ac3dbc4e053801$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $f3ac3dbc4e053801$export$2e2bcd8739ae039 = {
    'ai-mate.chat-error-banner.description': "Tu historial de chat se guarda durante un m\xe1ximo de 30 d\xedas.",
    'ai-mate.chat-error-banner.title': 'Iniciar nuevo chat',
    'ai-mate.chat-error.description': 'Prueba a <btn>volver a cargar el chat</btn>.',
    'ai-mate.chat-error.rate-limited-description': "Has alcanzado el n\xfamero m\xe1ximo de solicitudes. Int\xe9ntalo de nuevo m\xe1s tarde.",
    'ai-mate.chat-error.rate-limited-title': 'Demasiadas solicitudes',
    'ai-mate.chat-error.rovo-inactive-description': "Parece que Rovo no est\xe1 activado en tu sitio. <link>Configurar Rovo</link>",
    'ai-mate.chat-error.rovo-inactive-title': "Rovo est\xe1 inactivo",
    'ai-mate.chat-error.title': "No tenemos claro qu\xe9 ha salido mal",
    'ai-mate.main-chat.close-chat-button-label': 'Cerrar',
    'ai-mate.main-chat.maximize-chat-button-label': 'Pantalla completa',
    'ai-mate.main-chat.minimize-chat-button-label': 'Restablecer vista',
    'ai-mate.main-chat.new-chat-button-label': 'Nuevo',
    'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nuevo chat',
    'conversation-assistant-button.label': 'Chat',
    'conversation-assistant-button.rovo-chat-label': 'Chat de Rovo',
    'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Enviar',
    'highlight-actions.rovo-chat-custom-prompt.placeholder': "Preg\xfantale a la IA sobre esto",
    'highlight-actions.rovo-chat-explain-option.text': 'Explicar',
    'highlight-actions.rovo-chat-explain-prompt': "Explica esto reformul\xe1ndolo y a\xf1adiendo m\xe1s detalles, pero utiliza un lenguaje muy sencillo y frases cortas, y define o pon ejemplos para todos los t\xe9rminos t\xe9cnicos empleados en el texto original.",
    'highlight-actions.rovo-chat-find-resources-option.text': 'Encontrar recursos',
    'highlight-actions.rovo-chat-find-resources-prompt': "Encuentra recursos \xfanicamente de la base de conocimiento de la organizaci\xf3n que corroboren las afirmaciones realizadas.",
    'highlight-actions.rovo-chat-give-examples-option.text': 'Proporciona ejemplos',
    'highlight-actions.rovo-chat-give-examples-prompt': "Pon ejemplos de esto extra\xeddos de los recursos de la organizaci\xf3n o del conocimiento p\xfablico. Si no hay ning\xfan recurso que se pueda proporcionar, intenta poner un ejemplo metaf\xf3rico que pueda ayudar a alguien a entenderlo mejor.",
    'highlight-actions.rovo-chat-give-feedback-option.text': 'Enviar comentarios',
    'highlight-actions.rovo-chat-give-feedback-prompt': "Revisa la redacci\xf3n de este texto y dame tu opini\xf3n. Haz comentarios sobre la elecci\xf3n de palabras, la gram\xe1tica y la puntuaci\xf3n. Hazlo de forma positiva y entusiasta, pero aporta siempre al menos una cosa que mejorar o cambiar.",
    'highlight-actions.rovo-chat-more-options.tooltip': 'Recomendaciones de chat',
    'highlight-actions.rovo-chat-open-chat.tooltip': 'Abrir chat',
    'highlight-actions.rovo-chat-summarize-option.text': 'Resumir',
    'highlight-actions.rovo-chat-summarize-prompt': "Resalta los puntos clave de esto. C\xe9ntrate en la informaci\xf3n esencial y excluye los detalles innecesarios. Ofrece una descripci\xf3n concisa en un solo p\xe1rrafo.",
    'highlight-actions.rovo-chat.button-text': 'Chat',
    'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Preguntar en el chat',
    'horizontal-scroll-container.scroll-left': 'Desplazarse a la izquierda',
    'horizontal-scroll-container.scroll-right': 'Desplazarse a la derecha'
};

});


//# sourceMappingURL=es.c65361dc.js.map
